export function getCardTypeByIssuer(issuer?: string) {
    if (!issuer) {
        return undefined;
    }
    const paymentOptions = ['visa', 'mastercard', 'maestro', 'amex'];

    return paymentOptions.find(option => issuer.toLowerCase().includes(option))?.toUpperCase();
}
